

<app-modal-header
  (close)="close()">
  <span slot="title">
    <ng-container *ngIf="(sessionAttendanceComponent?.sessionAttendance$ | async) as sa">
      {{ sa.shopItem.title }}      
    </ng-container>
  </span>
  <span slot="breadcrumb">
    <ng-container *ngIf="(sessionAttendanceComponent?.sessionAttendance$ | async) as sa">
      <span class="">{{ 'admin.session-attendance-modal.breadcrumb.attendance' | translate }} •</span>
      <span class="font-normal lowercase">
        {{ sa.session.index + 1 }}. {{ 'admin.session-attendance-modal.breadcrumb.session' | translate }}
      </span>
    </ng-container>
  </span>

  <span *ngIf="(sessionAttendanceComponent?.sessionAttendance$ | async) as sa" class="details-block-wrap">
    <span class="detail-block">
      <span class="capitalize">
        {{ sa.session.startAt | localizedDate:'EEEEEE':undefined:'UTC+0' }} 
      </span>
      <span>&nbsp;</span>
      <span>
        {{ sa.session.startAt | localizedDate:'H:mm':undefined:'UTC+0' }} - {{ sa.session.endAt | localizedDate:'H:mm':undefined:'UTC+0' }}
      </span>
    </span>
    <span class="detail-block">
      {{ sa.session.startAt | localizedDate:'d.L.':undefined:'UTC+0' }}
    </span>

    <span class="detail-block">
      {{ sa.session.location | locationName:{ useInternalTitle: true, isOnline: sa.session.format===SessionFormat.ONLINE }  }}
    </span>
  </span>

</app-modal-header>

<div class="modal-body">

  <app-session-attendance #sessionAttendanceEl [sessionUuid]="sessionUuid"></app-session-attendance>

</div>

<div class="modal-footer">


  <app-modal-footer-menu [items]="footerMenuItems"></app-modal-footer-menu>

</div>


<ng-template #downloadModal>

  <app-modal-header
    (close)="downloadModalRef?.close()">
    <span slot="breadcrumb">
      {{ 'admin.session-attendance-modal.download.modal.breadcrumb' | translate }}
    </span>
  </app-modal-header>

  <div class="modal-body">
    <div class="compensate-modal-body-x-padding">
      <p-menu
        [popup]="false"
        [model]="downloadMenuItems"
        styleClass="w-full border-0"
        class="mobile-menu">
      </p-menu>
    </div>
  </div>

</ng-template>